<template>
  <span class="additional-attendee-label-directive truncate-text"
    ><span>{{ attendee.emailAddress }}</span></span
  >
</template>

<script>
// Vue equivalent of the `additionalAttendeeLabel` Angular directive. Same as ResourceLabelComponent:
// the directive is now hostless and step 18 deletes it.
export default {
  name: 'AdditionalAttendeeLabelComponent',
  props: {
    attendee: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
